(function() {
    'use strict';
  
    angular
      .module('iqxCore')
      .service('webViewSvc', webViewSvc)

    function webViewSvc(ApplicationSvc) {
        var svc=this
        svc.check=check
        svc.isWebView=false

        ////////////////////

        function checkAndroid(){
            if(document.referrer.includes('android-app://')){
                window.sessionStorage.setItem('isAndroidWebView', document.referrer.includes('android-app://'))
                svc.isWebView=true
            } else {
                svc.isWebView=!!window.sessionStorage.getItem('isAndroidWebView')
            }
        }

        function check(){
            var userAgent = window.navigator.userAgent.toLowerCase(),
            safari = /zzzsafari/.test( userAgent ),
            ios = /iphone|ipod|ipad/.test( userAgent )

            if( ios ) {
                if ( !safari ) {
                    svc.isWebView = true
                }
            } else {
                checkAndroid()
            }

            ApplicationSvc.isWebView=svc.isWebView
        }
    }
})()